import { getColor } from '../../../../theme-tools';
import { asMultiStyleConfig } from '../../../../utils/theme';
import { getDefaults } from './inputDefaults';
var parts = ['list', 'item'];
var baseStyleList = {
  borderRadius: 'base',
  boxShadow: "0 4px 12px -5px rgba(0,0,0,0.2)",
  border: '1px solid',
  borderColor: 'grey.300'
};
function baseStyleItem(props) {
  var {
    theme
  } = props;
  var {
    focusBoxShadowColor,
    outlineFocusColor
  } = getDefaults(props);
  return {
    py: [5, 4, 2],
    textDecoration: 'none',
    fontWeight: 'semibold',
    letterSpacing: '0.2px',
    color: 'blue.275',
    _hover: {
      bg: {
        base: 'none',
        md: 'blue.1140'
      },
      outline: 'none',
      boxShadow: 'none'
    },
    _active: {
      bg: 'blue.250'
    },
    _focus: {
      bg: 'white',
      outline: "2px solid ".concat(getColor(theme, outlineFocusColor)),
      boxShadow: "0 0 3px 2px ".concat(getColor(theme, focusBoxShadowColor))
    }
  };
}
var baseStyle = props => ({
  list: baseStyleList,
  item: baseStyleItem(props)
});
export var Menu = asMultiStyleConfig({
  parts,
  baseStyle
});